import React, { useEffect, useState } from 'react';
import clone from 'lodash.clonedeep';
import { EVENT_PARTICIPATION_TYPES, EVENT_TYPE_HYBRID, PAGE_TYPE_REGISTRATION } from '../constants';
import { usePagesContext } from '../context/PagesContext';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Table } from "react-bootstrap";
import PagesListTableItem from './PagesListTableItem';
import Tooltip from '../../../UI/Tooltip';
import locale from '../../../../locale';


const PagesListTable = ({event}) => {
    const {pages, handleUpdatePage, handleSortPages} = usePagesContext();
    const [pagesList, updatePagesList] = useState(null);

    useEffect(() => {
        updatePagesList(clone(pages));
    }, [pages]);

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const reorderedPages = reorder(
            pages,
            result.source.index,
            result.destination.index
        );

        updatePagesList(reorderedPages);
        handleSortPages(reorderedPages.map(({id}) => id));
    }

    function reorder(list, startIndex, endIndex) {
        const result = clone(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    function onVisibilityUpdate(pageId, field, value) {
        const result = pagesList.map((page) => {
            if (page.id === pageId) {
                const updatedPage = {...page, [field]: value};
                handleUpdatePage(updatedPage);

                return updatedPage;
            }

            return page;
        });

        updatePagesList(result);
    }

    function handleUpdateDefaultType(selectedPage, value) {
        const result = pagesList.map((page) => {
            if (page.id === selectedPage.id) {
                const updatedPage = {...page, defaultType: value};
                handleUpdatePage(updatedPage);

                return updatedPage;
            }

            if (page.id !== selectedPage.id && (
                (EVENT_PARTICIPATION_TYPES.includes(page.defaultType) && value === EVENT_TYPE_HYBRID)
                || (page.defaultType === EVENT_TYPE_HYBRID && value !== EVENT_TYPE_HYBRID)
                || page.defaultType === value
            )) {
                const updatedPage = {...page, defaultType: ''};
                handleUpdatePage(updatedPage);

                return updatedPage;
            }

            return page;
        });

        updatePagesList(result);
    }

    return (
        <Table>
            <thead>
                <tr>
                    <th></th>
                    <th>{locale('pages.pageName')}</th>
                    <th>
                        {locale('pages.openForMembers')}
                        <Tooltip width="300px">
                            {locale('pages.openForMembersTooltip')}
                        </Tooltip>
                    </th>
                    <th>
                        {locale('pages.openByDefault')}
                        <Tooltip width="300px">
                            {locale('pages.openByDefaultTooltip')}
                        </Tooltip>
                    </th>
                    <th>{locale('pages.actions')}</th>
                </tr>
            </thead>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <tbody
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {pagesList?.map((page, index) => (
                                <Draggable
                                    key={page.path}
                                    draggableId={`${page.path || index}`}
                                    index={index}
                                    isDragDisabled={page.type === PAGE_TYPE_REGISTRATION}
                                >
                                    {(provided) => (
                                        <tr
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={
                                                {
                                                    ...provided.draggableProps.style,
                                                    opacity: page.visible ? 1 : 0.7,
                                                }
                                            }
                                        >
                                            <PagesListTableItem
                                                key={page.path}
                                                page={page}
                                                onVisibilityUpdate={onVisibilityUpdate}
                                                onUpdateDefaultType={handleUpdateDefaultType}
                                            />
                                        </tr>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </tbody>
                    )}
                </Droppable>
            </DragDropContext>
        </Table>
    )
};

 export default PagesListTable;

